










import ReportedIssues from './scripts';

export default ReportedIssues;
